var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9304885,0.675421553 C14.4246615,0.988073752 14.5922263,1.62205197 14.3332784,2.13330078 L14.2797031,2.22761328 L7.23553204,13.3626737 C7.14274937,13.5620953 6.99066135,13.7364301 6.78681485,13.856499 C6.62929711,13.9492795 6.45842449,13.99932 6.28766025,14.0101025 C6.05459731,14.0271877 5.81468425,13.9727255 5.60251134,13.8384884 C5.4308658,13.7298921 5.29862371,13.5825297 5.20997149,13.415009 L0.405833706,7.52706388 C0.090501181,6.99170945 0.26886418,6.30209142 0.804218612,5.98675889 C1.30611339,5.69113465 1.94359142,5.82942249 2.28114164,6.28898171 L2.3445236,6.3851438 L6.086,10.96898 L12.3782967,1.02463615 C12.7104897,0.499577292 13.4054296,0.343228591 13.9304885,0.675421553 Z",
    id: "check",
    fill: "current",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.90386d395b1c456b7d596cc82a0256ba.svg";
export { ForwardRef as ReactComponent };